// CHG-131 Step 5: 프로필 API 클라이언트
import api from '../lib/axios';
import type { ApiResponse, ProfileColorKey } from '@maios/shared';

export interface MyProfile {
  userId: string;
  id: string;          // server compat alias of userId
  name: string;
  firstName: string | null;
  lastName: string | null;
  email: string;
  avatarUrl: string | null;
  displayColor: ProfileColorKey | null;
  nickname: string | null;
  jobTitle: string | null;
  jobRank: string | null;
  birthday: string | null;
  phone: string | null;
  memo: string | null;
  profileVisibility: ProfileVisibility;
  profileUpdatedAt: string | null;
  // server compat — 기존 /me/profile 응답 유지
  role?: string | null;
  githubUsername?: string | null;
  createdAt?: string | null;
}

export type ProfileVisibility = {
  nickname?: boolean;
  jobTitle?: boolean;
  jobRank?: boolean;
  birthday?: boolean;
  phone?: boolean;
  memo?: boolean;
};

export interface UpdateProfileInput {
  // CHG-131: name은 firstName/lastName 입력 시 서버에서 자동 계산. 단일 입력 호환용으로만 옵셔널 유지.
  name?: string;
  firstName?: string;
  lastName?: string | null;
  nickname?: string | null;
  jobTitle?: string | null;
  jobRank?: string | null;
  birthday?: string | null;
  phone?: string | null;
  memo?: string | null;
  displayColor?: ProfileColorKey;
  profileVisibility?: ProfileVisibility;
  githubUsername?: string | null;
}

export async function fetchMyProfile(): Promise<MyProfile> {
  const res = await api.get<ApiResponse<MyProfile>>('/users/me/profile');
  return res.data.data!;
}

export async function updateMyProfile(input: UpdateProfileInput): Promise<MyProfile> {
  const res = await api.put<ApiResponse<MyProfile>>('/users/me/profile', input);
  return res.data.data!;
}

export async function uploadAvatar(file: File): Promise<{ avatarUrl: string }> {
  const fd = new FormData();
  fd.append('file', file);
  const res = await api.post<ApiResponse<{ avatarUrl: string }>>('/users/me/profile/avatar', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data!;
}

export async function deleteAvatar(): Promise<void> {
  await api.delete('/users/me/profile/avatar');
}

export interface PublicProfile {
  userId: string;
  name: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  avatarUrl: string | null;
  displayColor: ProfileColorKey | null;
  nickname?: string | null;
  jobTitle?: string | null;
  jobRank?: string | null;
  birthday?: string | null;
  phone?: string | null;
  memo?: string | null;
  // 본인 조회 시에만 포함 (편집 화면 호환)
  profileVisibility?: ProfileVisibility;
}

export async function fetchPublicProfile(userId: string): Promise<PublicProfile> {
  const res = await api.get<ApiResponse<PublicProfile>>(`/users/${userId}/profile/public`);
  return res.data.data!;
}
